import InputField from "../atoms/InputField";

/**
 * SalesInputRow - 入力行 (ラベル + 金額入力 + 税率入力)
 * table の tbody 内で使用する (<tr> を返す)
 *
 * 単位 (円/%) は InputField 内部に内包するため、独立した <td> は持たない。
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {string} label                 - 項目名 (例: 現金売上)
 * @param {string} amount                - 金額の入力値
 * @param {function} onAmountChange      - 金額変更ハンドラ
 * @param {string} taxRate               - 税率の入力値
 * @param {function} onTaxRateChange     - 税率変更ハンドラ
 * @param {boolean} showTaxRate          - 税率入力欄を表示するか (デフォルト true)
 * @param {string} labelClass            - ラベルセルのクラス
 * @param {string} inputCellClass        - 入力セルの padding クラス
 * @param {string} amountWidthClass      - 金額入力フィールドの幅クラス
 * @param {string} amountSizeClass       - 金額入力フィールドの padding / font-size クラス
 * @param {string} amountUnit            - 金額の単位ラベル (例: '円')
 * @param {string} amountUnitClass       - 金額単位ラベルのスタイルクラス
 * @param {string} taxWidthClass         - 税率入力フィールドの幅クラス
 * @param {string} taxSizeClass          - 税率入力フィールドの padding / font-size クラス
 * @param {string} taxUnit               - 税率の単位ラベル (例: '%')
 * @param {string} taxUnitClass          - 税率単位ラベルのスタイルクラス
 */
function SalesInputRow({
  label,
  amount,
  onAmountChange,
  // 税率関連 (一時無効)
  // taxRate,
  // onTaxRateChange,
  // showTaxRate = true,
  labelClass = "px-4 py-3 text-sm text-right whitespace-nowrap",
  inputCellClass = "px-4 py-3",
  amountWidthClass = "w-52",
  amountSizeClass = "px-2 py-1 text-sm",
  amountUnit = "円",
  amountUnitClass = "text-sm",
  trClassName = "",
  // taxWidthClass = "w-16",
  // taxSizeClass = "px-2 py-1 text-sm",
  // taxUnit = "%",
  // taxUnitClass = "text-sm",
}) {
  return (
    <tr className={trClassName}>
      <td className={labelClass}>{label}</td>
      <td className={inputCellClass}>
        <InputField
          value={amount}
          onChange={onAmountChange}
          widthClass={amountWidthClass}
          sizeClass={amountSizeClass}
          unit={amountUnit}
          unitClass={amountUnitClass}
        />
      </td>
      {/* 税率入力欄 (一時無効)
      {showTaxRate ? (
        <td className={inputCellClass}>
          <InputField
            value={taxRate}
            onChange={onTaxRateChange}
            widthClass={taxWidthClass}
            sizeClass={taxSizeClass}
            unit={taxUnit}
            unitClass={taxUnitClass}
          />
        </td>
      ) : (
        <td />
      )}
      */}
    </tr>
  );
}

export default SalesInputRow;
